import { css } from 'lit';
import { hostReset } from '../styles/mixins.js';
import * as t from '../styles/tokens.js';

export default [
  hostReset,
  css`
    :host {
      display: block;
    }

    /* ── Wrapper: default = top layout (flex-column) ───────────────── */

    .uwc-ff__wrapper {
      display: flex;
      flex-direction: column;
      gap: ${t.space2};
    }

    /* ── Left layout ─────────────────────────────────────────────────── */

    :host([label-pos='left']) .uwc-ff__wrapper {
      flex-direction: row;
      align-items: var(--uwc-ff-label-align, center);
      gap: ${t.space4};
    }

    :host([label-pos='left']) .uwc-ff__label {
      flex-shrink: 0;
      width: var(--uwc-ff-label-width, 9rem);
      padding-top: 0;
    }

    /* ── Label ───────────────────────────────────────────────────────── */

    .uwc-ff__label {
      display: block;
      font-size: ${t.fontSizeMd};
      font-weight: ${t.fontWeightMedium};
      color: ${t.text};
      line-height: 1.5;
      cursor: default;
      user-select: none;
    }

    .uwc-ff__label[data-required]::after {
      content: ' *';
      color: ${t.danger};
    }

    /* ── Field (control + error stacked) ─────────────────────────────── */

    .uwc-ff__field {
      display: flex;
      flex-direction: column;
      gap: ${t.space1};
      flex: 1;
      min-width: 0;
    }

    /* ── Inner control ───────────────────────────────────────────────── */

    .uwc-ff__control {
      display: block;
    }

    :host([fluid]) .uwc-ff__control {
      width: 100%;
    }

    /* ── Error message ───────────────────────────────────────────────── */

    .uwc-ff__error {
      display: block;
      font-size: ${t.fontSizeXs};
      font-weight: ${t.fontWeightMedium};
      color: ${t.danger};
      line-height: 1.4;
    }
  `,
];
